import template from './+page.svelte'
export default {
	template,
}
